import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { withFirebase } from '../Firebase';
import TagsInput from 'react-tagsinput';
import close from "../../components/assets/close.png";
import Tooltip from '@material-ui/core/Tooltip';
import editPicture from '../assets/icon_picture.svg'
import editAttachment from '../assets/icon_attachments.svg';
import { CircularProgress } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import uuid from 'uuid/v1';
import './EditionPage.css';

class EditionPage extends Component {

    render() {
        return (
            <EditionPageForm {...this.props} />
        );
    }

}

const INITIAL_STATE = {
    error: null,
    wronTag: false,
    newImage: false,
    newAttachements: [],
    processedNewAttachments: [],
    editionLoading: false,
    image: null,
};

class EditionPageFormBase extends Component {
    constructor(props) {
        super(props);

        this.state = {
            ...INITIAL_STATE,
            title: this.props.capsule.title,
            description: this.props.capsule.description,
            tags: this.props.capsule.tags,
            image_url: this.props.capsule.image_url_capsule,
            attachmentList: JSON.parse(JSON.stringify(this.props.capsule.attachments)) || [],
            processedNewAttachments: [],
            newAttachements: [],
        };
    }

    rejectTag = () => {
        this.setState({ wrongTag: true })
    }

    handleChangeTags = (tags) => {
        this.setState({ tags: tags, wrongTag: false });
    }

    handleChangeCover = e => {
        e.persist()
        if (e.target.files[0]) {
            this.addAttachement(e);
            const current_image = e.target.files[0];
            this.setState({ image_url: URL.createObjectURL(current_image), image: current_image });
        }
    }

    addAttachement = e => {
        e.persist()
        let { attachmentList, processedNewAttachments, newAttachements } = this.state
        let attachements = e.target.files
        for (let i = 0; i < attachements.length; ++i) {
            processedNewAttachments.push({ fileName: attachements[i].name, url: '' })
            newAttachements.push(attachements[i])
        }
        this.setState({ attachmentList, newAttachements, processedNewAttachments })
    }

    deleteAttachement = (index) => {
        const { attachmentList } = this.state
        let attachList = attachmentList
        attachList.splice(index, 1);
        this.setState({ attachmentList: attachList });
    }

    cancelNewAttachment = (index) => {
        const { processedNewAttachments, newAttachements } = this.state
        processedNewAttachments.splice(index, 1);
        newAttachements.splice(index, 1)
        this.setState({ processedNewAttachments, newAttachements });
    }

    onChange = event => {
        this.setState({ [event.target.name]: event.target.value });
    };

    onSubmit = async (event) => {
        this.setState({ editionLoading: true });
        event.preventDefault();
        const { title, description, tags, attachmentList, image, newAttachements } = this.state;
        const { capsuleId } = this.props
        this.props.capsule.title = title
        this.props.capsule.description = description
        this.props.capsule.tags = tags
        this.props.capsule.attachments = attachmentList

        let url = this.props.capsule.image_url_capsule;
        if (image) {
            let imageUuid = uuid();
            await this.props.firebase.storage.ref(`images/${imageUuid}`).put(image)
            url = await this.props.firebase.storage.ref('images').child(imageUuid).getDownloadURL()
            this.props.capsule.image_url_capsule = url
        }
        if (newAttachements.length > 0) {
            for (const attachment of newAttachements) {
                let attachmentUuid = uuid();
                await this.props.firebase.storage.ref(`PJ/${attachmentUuid}`).put(attachment)
                let url = await this.props.firebase.storage.ref('PJ').child(attachmentUuid).getDownloadURL()
                attachmentList.push({ fileName: attachment.name, url });
            }
        }


        await this.props.firebase.db.collection('capsules').doc(capsuleId).update({
            title: title,
            description: description,
            attachments: attachmentList,
            tags: tags,
            image_url_capsule: url
        });
        this.setState({ editionLoading: false })
        this.props.onClose();
    };

    render() {
        const { capsule, classes } = this.props
        const { title, description, tags, attachmentList, image_url, processedNewAttachments, editionLoading, error } = this.state
        return (
            <>
                <div className="edition-cps-header">
                    <img src={image_url} className="edition-bg" alt="edit-bg" />
                    <div className="edit-header-mask"></div>
                    <div className="edition-title z-index-3">Editer la capsule</div>
                </div>

                <div className="d-flex justify-content-center">
                    <label htmlFor="import-picture" className="import z-index-3">
                        <Tooltip title="Photo de couverture" aria-label="cover">
                            <img alt="icon" className="position-icon cursor-pointer" src={editPicture} />
                        </Tooltip>
                    </label>
                    <input onChange={this.handleChangeCover} hidden={true} id="import-picture" className="import" type="file" />
                    <label htmlFor="import-attachement" className="z-index-3">
                        <Tooltip title="Pièces jointes" aria-label="attachment">
                            <img alt="icon" className="position-icon cursor-pointer" type="file" src={editAttachment} />
                        </Tooltip>
                    </label>
                    <input onChange={this.addAttachement} hidden={true} id="import-attachement" className="import" type="file" multiple />
                </div>

                <form onSubmit={this.onSubmit}>
                    <div className="d-flex flex-column align-items-center">
                        <div hidden={attachmentList.length === 0}>
                            {attachmentList.map((attachment, index) =>
                                <div className="d-flex" key={attachment.fileName + index}>
                                    <img onClick={() => this.deleteAttachement(index)} src={close} className="close cursor-pointer" alt="attachment"></img>
                                    <h1 className="fichier">{attachment.fileName}</h1>
                                </div>)}
                        </div>
                        {processedNewAttachments.map((attachment, index) =>
                            <div className="d-flex" key={attachment.fileName + index}>
                                <img onClick={() => this.cancelNewAttachment(index)} src={close} className="close cursor-pointer" alt="attachment"></img>
                                <h1 className="fichier">{attachment.fileName}</h1>
                            </div>)}
                    </div>
                    <div className="modal-poll-form-container-mobile">

                        <div>
                            <div className="modal-poll-form-group">
                                <label htmlFor="title" className="modal-poll-basic-text">Titre</label>
                                <input onChange={this.onChange} value={title} type="modal-poll" className="modal-poll-question-field container placeholder-label" name="title" placeholder={capsule.title} />

                                <label htmlFor="title" className="modal-poll-basic-text">Description</label>
                                <textarea onChange={this.onChange} value={description} type="modal-poll" className="modal-poll-question-field container placeholder-label" name="description"></textarea>

                                <div className="text-center">
                                    <h1 className="mb-2 title-theme pl-2">Thème(s) associé(s)</h1>
                                    <TagsInput onValidationReject={this.rejectTag} validationRegex={/^[a-zA-Z0-9]{0,25}$/} maxTags={6} value={tags} onChange={this.handleChangeTags} />
                                </div>
                                <div hidden={!this.state.wrongTag}><h4 className="wrong-tag mt-2">Tag non valide</h4></div>

                                <div className="d-flex justify-content-center pt-4 pb-2 position-relative">
                                    <button type="submit" className="ok-poll-button" disabled={description.length === 0 || title.length === 0 || editionLoading}>OK</button>
                                    {editionLoading && <CircularProgress size={30} className={classes.buttonProgress} />}
                                </div>


                            </div>
                        </div>

                        {error && <p>{error.message}</p>}
                    </div>

                </form>
            </>
        );
    }
}

EditionPageFormBase.propTypes = {
    classes: PropTypes.object.isRequired,
};

const styles_loader = theme => ({
    root: {
    },
    buttonProgress: {
        color: '#0070A2',
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -8,
        marginLeft: -15,
    },
});

const EditionPageForm = withRouter(withFirebase(withStyles(styles_loader)(EditionPageFormBase)));

export default EditionPage;
export { EditionPageForm };